module.exports = __webpack_public_path__ + "static/media/man-with-women.8b1bf347.jpg";